import { ThemeSpacing } from '../../core/theme/ASQTheme';

export function themeSpacingToPx(spacing: number): number {
  return spacing * ThemeSpacing;
}
